import { createContext, useContext, useState, useEffect } from 'react';

export const THEMES = {
  darkCyber: {
    name: "Dark Cyber",
    emoji: "🖥️",
    bg: "#0a0e1a", surface: "#111827", border: "#1f2d45",
    accent: "#3b82f6", accentGlow: "rgba(59,130,246,0.15)",
    green: "#10b981", greenGlow: "rgba(16,185,129,0.15)",
    red: "#ef4444", redGlow: "rgba(239,68,68,0.15)",
    amber: "#f59e0b", amberGlow: "rgba(245,158,11,0.15)",
    text: "#f1f5f9", textMuted: "#64748b",
    navBg: "#111827", cardShadow: "none",
    inputBg: "#0a0e1a",
  },
  neonBlue: {
    name: "Neon Blue",
    emoji: "⚡",
    bg: "#020818", surface: "#050f2e", border: "#0a2557",
    accent: "#00d4ff", accentGlow: "rgba(0,212,255,0.2)",
    green: "#00ff9f", greenGlow: "rgba(0,255,159,0.2)",
    red: "#ff3d71", redGlow: "rgba(255,61,113,0.2)",
    amber: "#ffaa00", amberGlow: "rgba(255,170,0,0.2)",
    text: "#e0f7ff", textMuted: "#3a7bd5",
    navBg: "#050f2e", cardShadow: "0 0 20px rgba(0,212,255,0.08)",
    inputBg: "#020818",
  },
  neonPurple: {
    name: "Neon Purple",
    emoji: "🌆",
    bg: "#0d0015", surface: "#130020", border: "#2d0050",
    accent: "#bf00ff", accentGlow: "rgba(191,0,255,0.2)",
    green: "#00ff9f", greenGlow: "rgba(0,255,159,0.2)",
    red: "#ff3d71", redGlow: "rgba(255,61,113,0.2)",
    amber: "#ff9f00", amberGlow: "rgba(255,159,0,0.2)",
    text: "#f0d6ff", textMuted: "#7b4fa6",
    navBg: "#130020", cardShadow: "0 0 20px rgba(191,0,255,0.08)",
    inputBg: "#0d0015",
  },
  cyberGreen: {
    name: "Cyber Green",
    emoji: "💚",
    bg: "#000d00", surface: "#001a00", border: "#003300",
    accent: "#00ff41", accentGlow: "rgba(0,255,65,0.15)",
    green: "#00ff41", greenGlow: "rgba(0,255,65,0.2)",
    red: "#ff3d3d", redGlow: "rgba(255,61,61,0.2)",
    amber: "#ffe000", amberGlow: "rgba(255,224,0,0.2)",
    text: "#ccffcc", textMuted: "#2d6e2d",
    navBg: "#001a00", cardShadow: "0 0 20px rgba(0,255,65,0.06)",
    inputBg: "#000d00",
  },
  cyberRed: {
    name: "Cyber Red",
    emoji: "🔴",
    bg: "#0d0000", surface: "#1a0000", border: "#3d0000",
    accent: "#ff2020", accentGlow: "rgba(255,32,32,0.2)",
    green: "#00ff9f", greenGlow: "rgba(0,255,159,0.2)",
    red: "#ff2020", redGlow: "rgba(255,32,32,0.25)",
    amber: "#ff8c00", amberGlow: "rgba(255,140,0,0.2)",
    text: "#ffe0e0", textMuted: "#6e2d2d",
    navBg: "#1a0000", cardShadow: "0 0 20px rgba(255,32,32,0.08)",
    inputBg: "#0d0000",
  },
  midnightPurple: {
    name: "Midnight Purple",
    emoji: "🌙",
    bg: "#0f0a1e", surface: "#1a1232", border: "#2e1f50",
    accent: "#8b5cf6", accentGlow: "rgba(139,92,246,0.15)",
    green: "#10b981", greenGlow: "rgba(16,185,129,0.15)",
    red: "#ef4444", redGlow: "rgba(239,68,68,0.15)",
    amber: "#f59e0b", amberGlow: "rgba(245,158,11,0.15)",
    text: "#ede9fe", textMuted: "#6d5a8a",
    navBg: "#1a1232", cardShadow: "none",
    inputBg: "#0f0a1e",
  },
  softLight: {
    name: "Soft Light",
    emoji: "☀️",
    bg: "#f8fafc", surface: "#ffffff", border: "#e2e8f0",
    accent: "#3b82f6", accentGlow: "rgba(59,130,246,0.1)",
    green: "#059669", greenGlow: "rgba(5,150,105,0.1)",
    red: "#dc2626", redGlow: "rgba(220,38,38,0.1)",
    amber: "#d97706", amberGlow: "rgba(217,119,6,0.1)",
    text: "#0f172a", textMuted: "#94a3b8",
    navBg: "#ffffff", cardShadow: "0 1px 3px rgba(0,0,0,0.08)",
    inputBg: "#f1f5f9",
  },
  forest: {
    name: "Forest",
    emoji: "🌲",
    bg: "#050f08", surface: "#0a1a0f", border: "#1a3320",
    accent: "#22c55e", accentGlow: "rgba(34,197,94,0.15)",
    green: "#22c55e", greenGlow: "rgba(34,197,94,0.2)",
    red: "#ef4444", redGlow: "rgba(239,68,68,0.15)",
    amber: "#f59e0b", amberGlow: "rgba(245,158,11,0.15)",
    text: "#dcfce7", textMuted: "#4a7c59",
    navBg: "#0a1a0f", cardShadow: "none",
    inputBg: "#050f08",
  },
  botanical: {
    name: "Botanical",
    emoji: "🌿",
    bg: "#f5f0e8", surface: "#fdfaf4", border: "#ddd5c0",
    accent: "#4a7c3f", accentGlow: "rgba(74,124,63,0.12)",
    green: "#4a7c3f", greenGlow: "rgba(74,124,63,0.15)",
    red: "#c0392b", redGlow: "rgba(192,57,43,0.12)",
    amber: "#a0522d", amberGlow: "rgba(160,82,45,0.12)",
    text: "#2c1f0e", textMuted: "#8a7560",
    navBg: "#fdfaf4", cardShadow: "0 1px 4px rgba(74,60,30,0.08)",
    inputBg: "#f0ebe0",
  },
};

const ThemeContext = createContext(null);

export const ThemeProvider = ({ children }) => {
  const [themeKey, setThemeKey] = useState(() => {
    return localStorage.getItem('ledger_theme') || 'darkCyber';
  });

  const setTheme = (key) => {
    setThemeKey(key);
    localStorage.setItem('ledger_theme', key);
  };

  const COLORS = THEMES[themeKey] || THEMES.darkCyber;

  return (
    <ThemeContext.Provider value={{ COLORS, themeKey, setTheme, THEMES }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
